import arrayUniq from "array-uniq";
import {trackPromise} from "react-promise-tracker";
import Call from "../service/axios";

const getSearchOptions = async (url, fieldName) => {
  const SearchUrl = `${url}search/?field=${fieldName}`;
  const {data = []} = await trackPromise(Call.get(SearchUrl));
  //filtering for empty string
  let filteredData = data.filter((value) => !!value);
  //removing duplicate entries
  let results = arrayUniq(filteredData);
  return results?.map((data) => {
    return {label: data.toString(), value: data.toString()};
  });
};

export default getSearchOptions;
